import { render } from "./videoTemplate.vue?vue&type=template&id=7f5d4a6a&scoped=true"
import script from "./videoTemplate.vue?vue&type=script&lang=js"
export * from "./videoTemplate.vue?vue&type=script&lang=js"

import "./videoTemplate.vue?vue&type=style&index=0&id=7f5d4a6a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5d4a6a"]])

export default __exports__